// extracted by mini-css-extract-plugin
module.exports = {"play-btn":"video_play-btn__UQyoD","video":"video_video__YYUb5","video-wrapper":"video_video-wrapper__edl6K"};